import { render, staticRenderFns } from "./CloseCoupon.vue?vue&type=template&id=2504e52a&scoped=true"
import script from "./CloseCoupon.vue?vue&type=script&lang=js"
export * from "./CloseCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2504e52a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2504e52a')) {
      api.createRecord('2504e52a', component.options)
    } else {
      api.reload('2504e52a', component.options)
    }
    module.hot.accept("./CloseCoupon.vue?vue&type=template&id=2504e52a&scoped=true", function () {
      api.rerender('2504e52a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/salesPromotion/list/modules/CloseCoupon.vue"
export default component.exports